import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {FormGroup, ReactiveFormsModule, ValidationErrors} from '@angular/forms';
import {DrmErrorsComponent} from './drm-errors.component';

export interface DrmTierDialogData {
  headline: string;
  actionName: string;
  /**
   * The tier's own control, edited in place: the rules across tiers read its siblings, which a
   * detached copy could not see. The caller restores or removes it on cancel.
   */
  tier: FormGroup;
  streamTypes: string[];
  /** The last tier has no upper bound, so it has no width to set. */
  isLast: boolean;
  /** The rules across all tiers, read live. */
  setErrors: () => ValidationErrors | null;
  /** Show errors on opening; a tier just added waits until the operator has touched a field. */
  revealErrors: boolean;
}

/** Closes with `true` when the operator confirms, `false` (or nothing) when they cancel. */
@Component({
  selector: 'app-drm-tier-dialog',
  templateUrl: './drm-tier-dialog.component.html',
  imports: [ReactiveFormsModule, DrmErrorsComponent],
})
export class DrmTierDialogComponent {
  constructor(public dialogRef: DialogRef<boolean>,
              @Inject(DIALOG_DATA) public data: DrmTierDialogData) {
  }

  get tier(): FormGroup { return this.data.tier; }

  get showErrors(): boolean { return this.data.revealErrors || this.tier.dirty || this.tier.touched; }
}
